
import CustomButton from "../../../components/CustomButton";
import CustomInput from "../../../components/CustomInput";
import CustomPagination from "../../../components/admin/CustomPagination";
import CustomHeader from "../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../components/admin/CustomLeftBar";
import React, { Children, useEffect, useState } from "react";
import { DashboardApi } from "../../../callApi/dashboard";
import { getProductApi } from "../../../callApi/productApi";
import { hostImg } from "../../../callApi/AxiosCall";
import Notiflix from "notiflix";
import parse from "html-react-parser";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import CustomInputProduct from "../../../components/CustomInputProduct";
import { useNavigate } from "react-router-dom";

ChartJS.register(ArcElement, Tooltip, Legend);
export default function AdminHome() {
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [searchValue, setsearchValue] = useState("");
  const [DashboardData, setDashboardData] = useState(null);
  const [productItem, setproductItem] = useState(null);
  const [allProduct, setallProduct] = useState(0);
  const router = useNavigate();
  const [series, setseries] = useState(null);
  const [series2, setseries2] = useState(null);
  const [year, setyear] = useState({
    name: "ทั้งหมด",
    value: { start_date: "", end_date: "" },
  });
  const typeYear = [
    {
      name: "ทั้งหมด",
      value: { start_date: "", end_date: "" },
    },
    {
      name: "2024",
      value: { start_date: "2024-01-01", end_date: "2024-12-31" },
    },
    {
      name: "2023",
      value: { start_date: "2023-01-01", end_date: "2023-12-31" },
    },
  ];
  useEffect(() => {
    // callData();
    callproduct();
  }, []);

  useEffect(() => {
    callData();
  }, [year]);

  const callData = async () => {
    let res = await DashboardApi({
      end_date: year?.value?.end_date ?? "",
      start_date: year?.value?.start_date ?? "",
    });
    if (res.status == 200) {
      let temp = [...res.data.data];
      let tempDataset = {
        labels: [],
        datasets: [
          {
            label: "จำนวน",
            data: [],
            backgroundColor: ["#20ac65aa", "#f7bf07aa", "#d3893faa"],
            borderColor: ["#32593e", "#ce8a4c", "#8b5e3f"],
            borderWidth: 1,
          },
        ],
      };
      let tempDataset2 = {
        labels: [],
        datasets: [
          {
            label: "จำนวน",
            data: [],
            backgroundColor: [
              "#050C9Caa",
              "#3572EFaa",
              "#3ABEF9aa",
              "#A7E6FFaa",
            ],
            borderColor: ["#050C9C", "#3572EF", "#3ABEF9", "#A7E6FF"],
            borderWidth: 1,
          },
        ],
      };
      console.log(res.data.data);
      for (let i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].last?.content && i < 2) {
          temp[i].last.content = JSON.parse(res.data.data[i].last?.content);
          let FirstImg = null;
          let FirstText = null;
          for (let j = 0; j < temp[i].last.content?.html?.length; j++) {
            for (let k = 0; k < temp[i].last.content?.html[j].length; k++) {
              if (
                FirstImg == null &&
                temp[i].last.content?.html[j][k].type == "image"
              ) {
                FirstImg = temp[i].last.content?.html[j][k].value;
              } else if (
                FirstText == null &&
                temp[i].last.content?.html[j][k].type == "text"
              ) {
                FirstText = temp[i].last.content?.html[j][k].value;
              }
              if (FirstImg != null && FirstText != null) {
                break;
              }
            }
            if (FirstImg != null && FirstText != null) {
              break;
            }
          }
          temp[i].last.content.img = FirstImg;
          temp[i].last.content.text = FirstText;
        }
        if (i == 2) {
          for (let j = 0; j < res.data.data[i].economy_label.length; j++) {
            tempDataset.labels.push(
              res.data.data[i].economy_label[j].economy_label
            );
            tempDataset.datasets[0].data.push(
              res.data.data[i].economy_label[j].count_economy_label
            );
          }
        }
        if (i == 3) {
          for (let j = 0; j < res.data.data[i].product_type.length; j++) {
            tempDataset2.labels.push(
              res.data.data[i].product_type[j].product_type_name
            );
            tempDataset2.datasets[0].data.push(
              res.data.data[i].product_type[j].count_product_type
            );
          }
        }
      }
      console.log(tempDataset)
      console.log(tempDataset2)
      setseries(tempDataset);
      setseries2(tempDataset2);
      setDashboardData(temp);
    }
  };
  const callproduct = async () => {
    Notiflix.Loading.circle();
    let res = await getProductApi({
      page: nowPage,
      limit: 8,
      search: searchValue,
    });
    Notiflix.Loading.remove();
    if (res.status == 200) {
      setsearchValue("");
      setproductItem(res.data.data.products);
      setallPage(Math.ceil(res?.data?.data?.count / 8));
      setallProduct(res.data.data.count);
    }
  };
  const LocalProduct = () => {
    return (
      <div className="bg-white border rounded-lg drop-shadow-sm p-5">
        <div className="flex flex-row gap-3  items-center w-full">
          <p className="font_Kanit text-[24px] font-semibold">
            ข่าวและกิจกรรมล่าสุด
          </p>
          <div className="flex-[1]" />
          <CustomButton
            onClick={() => {
              router("/admin/post");
            }}
            txt={"ดูข่าวและกิจกรรมทั้งหมด"}
            bgcolor="#2271B1"
          />
        </div>
        {DashboardData[0]?.last ? (
          <div className="flex flex-col gap-5 items-start font_Kanit font-medium text-xl bg-white  rounded-lg mt-5 ">
            <img
              src={
                DashboardData[0]?.last?.content.img
                  ? "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                    DashboardData[0]?.last?.content.img
                  : "/img/logo.png"
              }
              className="w-full h-[200px] object-cover rounded-lg max-h-[200px]"
            />
            <div className=" font_Kanit flex flex-col ">
              <p className="text-[#B36427] font-bold text-[20px] line-clamp-1 text-ellipsis">
                {DashboardData ? DashboardData[0]?.last?.title : ""}
              </p>
              <div className="mt-7 font-medium text-sm line-clamp-6 overflow-hidden text-ellipsis ">
                {DashboardData[0]?.last?.content?.text != null ? (
                  <div>{parse(DashboardData[0]?.last?.content?.text)}</div>
                ) : (
                  <p></p>
                )}
              </div>
              {/* <CustomButton
              txt={"แก้ไขบทความ"}
              classAdditional="font_Kanit font-semibold text-lg self-center my-5"
            /> */}
            </div>
          </div>
        ) : null}
      </div>
    );
  };
  const Knowledge = () => {
    return (
      <div className="bg-white border rounded-lg drop-shadow-sm p-5">
        <div className="flex flex-row gap-3  items-center w-full">
          <p className="font_Kanit text-[24px] font-semibold">
            องค์ความรู้ล่าสุด
          </p>
          <div className="flex-[1]" />
          <CustomButton
            onClick={() => {
              router("/admin/post/knowledge");
            }}
            txt={"ดูองค์ความรู้ทั้งหมด"}
            bgcolor="#2271B1"
          />
        </div>
        {DashboardData[1]?.last ? (
          <div className="flex flex-col gap-5 items-start font_Kanit font-medium text-xl bg-white  rounded-lg mt-5 ">
            <img
              src={
                DashboardData[1]?.last.content.img
                  ? "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                    DashboardData[1]?.last.content.img
                  : "/img/logo.png"
              }
              className="w-full h-[200px] object-cover rounded-lg max-h-[200px]"
            />
            <div className=" font_Kanit flex flex-col ">
              <p className="text-[#B36427] font-bold text-[20px] line-clamp-1 text-ellipsis">
                {DashboardData ? DashboardData[1]?.last?.title : ""}
              </p>
              <div className="mt-7 font-medium text-sm line-clamp-6 overflow-hidden text-ellipsis ">
                {DashboardData[1]?.last?.content?.text != null ? (
                  <div>{parse(DashboardData[1]?.last?.content?.text)}</div>
                ) : (
                  <p></p>
                )}
              </div>
              {/* <CustomButton
              txt={"แก้ไขบทความ"}
              classAdditional="font_Kanit font-semibold text-lg self-center my-5"
            /> */}
            </div>
          </div>
        ) : null}
      </div>
    );
  };
  const LastProduct = () => {
    return (
      <div className="flex flex-col items-center gap-5 bg-white border rounded-lg drop-shadow-sm p-5">
        <div className="flex flex-row gap-3  items-center w-full">
          <p className="font_Kanit text-[24px] font-semibold">
            ผลิตภัณท์ท้องถิ่นล่าสุด
          </p>
          <div className="flex-[1]" />
          <CustomInput
            value={searchValue}
            onChange={(v) => setsearchValue(v)}
            placeHolder="ค้นหา"
            rightImg={"/img/Search.png"}
            onEnter={() => {
              callproduct();
            }}
          />
          <CustomButton
            onClick={() => {
              router("/admin/products");
            }}
            txt={"ดูผลิตภัณท์ทั้งหมด"}
            bgcolor="#2271B1"
          />
        </div>
        <div className="grid grid-cols-4 xl:grid-cols-8 gap-10">
          {productItem?.map((item, i) => {
            return (
              <div
                key={i}
                className="flex flex-col  items-center font_Kanit font-medium text-sm cursor-pointer  active:opacity-50 hover:opacity-80 "
              >
                <img
                  src={item.product_img ? hostImg + item.product_img : ""}
                  className="h-32 object-contain rounded-lg  drop-shadow-md max-h-[400px]"
                />
                <p className="mt-3">{item.no}</p>
                <p className="text-center">{item.name}</p>
              </div>
            );
          })}
        </div>
        <CustomPagination
          now={nowPage}
          all={allPage}
          onChangePage={(page) => {
            setnowPage(page);
          }}
        />
      </div>
    );
  };
  const Chart = () => {
    return (
      <div className="flex flex-col gap-3">
        <div className="grid grid-cols-2 gap-8 ">
          <div className="flex flex-col items-center h-[300px]">
            {series ? (
              <Pie
                data={series}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      align: "end",
                      position: "left",
                    },
                  },
                }}
              />
            ) : null}
          </div>
          <div className="flex flex-col items-center h-[300px]">
            {series ? (
              <Pie
                data={series2}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      align: "end",
                      position: "right",
                    },
                  },
                }}
              />
            ) : null}
          </div>
        </div>
        <div className="self-center w-28">
          <CustomInputProduct
            type="select"
            value={year}
            data={typeYear}
            placeHolder="เลือกปี"
            onChange={(item) => {
              setyear(item);
            }}
          />
        </div>
      </div>
    );
  };
  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Dashboard" />
        <div className="flex-[1] flex flex-col p-8 gap-5 overflow-y-auto">
          <div className="grid grid-cols-3 gap-5">
            <div className="rounded-lg p-2 drop-shadow-sm border bg-white flex flex-row gap-3">
              <img src="/img/icon1.png" className="object-contain w-14" />
              <div>
                <div className="font_Kanit text-[24px] font-bold">
                  {DashboardData ? DashboardData[0]?.news : ""}
                </div>
                <div className="font_Kanit text-sm font-semibold text-[#858485]">
                  จำนวนบทความข่าวและกิจกรรม
                </div>
              </div>
            </div>
            <div className="rounded-lg p-2 drop-shadow-sm border bg-white flex flex-row gap-3">
              <img src="/img/icon2.png" className="object-contain w-14" />
              <div>
                <div className="font_Kanit text-[24px] font-bold">
                  {DashboardData ? DashboardData[1]?.knowledge : ""}
                </div>
                <div className="font_Kanit text-sm font-semibold text-[#858485]">
                  จำนวนบทความองค์ความรู้
                </div>
              </div>
            </div>
            <div className="rounded-lg p-2 drop-shadow-sm border bg-white flex flex-row gap-3">
              <img src="/img/icon3.png" className="object-contain w-14" />
              <div>
                <div className="font_Kanit text-[24px] font-bold">
                  {allProduct}
                </div>
                <div className="font_Kanit text-sm font-semibold text-[#858485]">
                  จำนวนชิ้นงานผลิตภัณท์ท้องถิ่น
                </div>
              </div>
            </div>
          </div>
          {Chart()}

          {DashboardData ? (
            <div className="grid grid-cols-2 gap-5">
              <LocalProduct />
              <Knowledge />
            </div>
          ) : null}
          {LastProduct()}
        </div>
      </div>
    </div>
  );
}
